// extracted by mini-css-extract-plugin
module.exports = {"auth":"index_auth_3n2mU","container":"index_container_2npAW","googleSign":"index_googleSign_1SJwo","footerNav":"index_footerNav_1BQ9q"};